import type { EventName } from "@lit/react";
import { GridTreeToggle as GridTreeToggleElement, type GridTreeToggleEventMap as _GridTreeToggleEventMap, } from "@vaadin/grid/vaadin-grid-tree-toggle.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridTreeToggleElement, };
export type GridTreeToggleEventMap = Readonly<{
    onExpandedChanged: EventName<_GridTreeToggleEventMap["expanded-changed"]>;
}>;
const events = { onExpandedChanged: "expanded-changed" } as GridTreeToggleEventMap;
export type GridTreeToggleProps = WebComponentProps<GridTreeToggleElement, GridTreeToggleEventMap>;
export const GridTreeToggle = createComponent({
    elementClass: GridTreeToggleElement, events, react: React, tagName: "vaadin-grid-tree-toggle"
});
